import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('files.routes.index'),
        name: 'files',
        child: false,
        component: () =>
            import(/* webpackChunkName: "files" */ '@/views/files/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('files.breadcrumbs.index'),
                    to: { name: 'files' },
                    disable: true,
                },
            ],
            reseller: true,
            partner: true,
            showName: i18n.t('files.breadcrumbs.index'),
        },
    },
]
